import { AlternativeAutoComplete } from 'common/form/autoComplete/_alternativeAutoComplete'
import { Option } from 'common/form/autoComplete/_option'
import useInvoiceFilterForm from 'Pages/invoice/hooks/useInvoiceFilterForm'

export const InvoiceEmployee = () => {
  const { teacher } = useInvoiceFilterForm()

  return (
    <AlternativeAutoComplete
      className="invoice-filter-form__input-wide"
      // main input
      inputProps={{
        categoryList: [], // menu list in category dropdown
        categoryValue: { name: 'Giáo viên', value: '' }, // if not exist this value -> default category: categoryList[0]
        categoryWidth: 86,
        placeholder: 'Chọn giáo viên',
        readOnly: true,
        value: teacher.value?.name || '',
        onIconClick: () => teacher.onChange(null),
      }}
      // menu
      menuProps={{
        empty:
          teacher.listOrigin.length <= 0 ?  'Không tìm thấy giáo viên' : '',
      }}
      // search input in dropdown menu
      searchInputProps={{
        placeholder: 'Tìm kiếm giáo viên',
        value: teacher.keyword,
        onChange: teacher.onKeywordChange,
      }}
    >
      {teacher.list.length > 0 &&
      teacher.list.map(item => (
        <Option
          key={item.value}
          className="invoice-filter-form__option-text"
          data-active={item.value === teacher.value?.value}
          onClick={() => teacher.onChange(item)}
        >
          {item.name}
        </Option>
      ))}
    </AlternativeAutoComplete>
  )
}
